export default __webpack_public_path__ + "static/media/open-modal-icon.3012f000.svg";